import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

/**
 * Two-tone treasure chest: dark body + gold band/lock so it stays readable
 * on the light play-toolbar buttons.
 */
export default function TreasureChestIcon(props) {
    const { sx, ...rest } = props;
    return (
        <SvgIcon viewBox="0 0 24 24" sx={sx} {...rest}>
            <path
                fill="currentColor"
                d="M5 9.25h14V18a2.25 2.25 0 0 1-2.25 2.25H7.25A2.25 2.25 0 0 1 5 18V9.25Z"
            />
            <path
                fill="currentColor"
                d="M6.2 6.4C6.2 4.85 8.7 3.7 12 3.7s5.8 1.15 5.8 2.7V9.4H6.2V6.4Z"
            />
            <path fill="#d97706" d="M4.75 8.85h14.5v2.2H4.75z" />
            <rect fill="#facc15" x="10.35" y="12.15" width="3.3" height="4.35" rx="0.7" />
            <path
                fill="none"
                stroke="#facc15"
                strokeWidth="1.35"
                d="M11.05 12.2V11a.95.95 0 0 1 1.9 0v1.2"
            />
        </SvgIcon>
    );
}
